<input [ngClass]="{ 'is-invalid error': searchControl.errors && (searchControl.dirty || searchControl.touched) }" [formControl]="searchControl" class="form-control" id="employees">
<div>
	<ng-container *ngIf="searchControl.errors && (searchControl.dirty || searchControl.touched)">
		<small *ngIf="searchControl.errors.required" class="text-danger">Employee Id Field is Required</small>
	</ng-container>
</div>